/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Editor_SubtitleInputs */

const cs_templates_editor_subtitle = /** @type {(inputs: Templates_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravte šablonu, zobrazte náhled PDF a uložte. Dokumenty generujte z inzerátu.`)
};

const en_templates_editor_subtitle = /** @type {(inputs: Templates_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit the template, preview a PDF, then save. Generate documents from a listing.`)
};

/**
* | output |
* | --- |
* | "Edit the template, preview a PDF, then save. Generate documents from a listing." |
*
* @param {Templates_Editor_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_editor_subtitle = /** @type {((inputs?: Templates_Editor_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Editor_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_editor_subtitle(inputs)
	return cs_templates_editor_subtitle(inputs)
});